import { render } from "./DiscordAuth.vue?vue&type=template&id=bebfcdd4&ts=true"
import script from "./DiscordAuth.vue?vue&type=script&lang=ts"
export * from "./DiscordAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__